import { inject } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { AuthenticationService } from "../shared/Services/authentication.service";

export const tabletUserDataModifierGuard = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthenticationService);

  if (auth.isDealerTabletUser()) {
    route.data = {
      ...route.data,
      title: "menu.place_quote.add.description",
      back: "/dealer-system/quote/overview",
    };
  } else {
    route.data = {
      ...route.data,
      title: "menu.place_order.add.description",
      back: null,
    };
  }

  return true;
};
